import React, { useState } from "react";
import "./AttachmentViewer.scss";

type Props = {
  url: string;
};

export const AttachmentViewer = ({ url }: Props) => {
  const [isFullScreen, setIsFullScreen] = useState<boolean>(false);

  return (
    <>
      <div
        className={`image-container`}
        onClick={() => {
          setIsFullScreen(true);
        }}
        role="button"
        tabIndex={0}
      >
        <img src={url} alt={""} />
      </div>
      {isFullScreen && (
        <div
          className="full-screen"
          onClick={() => {
            setIsFullScreen(false);
          }}
          role="button"
          tabIndex={0}
        >
          <img src={url} alt={""} />
        </div>
      )}
    </>
  );
};
